<script setup>
import {computed, ref} from "vue";
import {useSearch} from "@/search";

const lastName = defineModel({type: String});
const props = defineProps({
    fieldProps: {
        type: Object,
    },
    patientList: {
        type: Array,
        default: () => [],
    },
});
const emit = defineEmits(['submit']);

const allPatients = computed(() => {
    return props.patientList;
});

const {query, searchResultsOrEmpty: patientsSearchResult, isSearching} = useSearch(
    allPatients, ['lastName'],
);

function submit(patient) {
    lastName.value = query.value;
    emit('submit', {patient});
}
</script>

<template>
    <main>
        <h1>{{ pgettext('title', 'Enter Last Name') }}</h1>

        <v-container>
            <v-row dense>
                <v-col cols="12">
                    <v-text-field clearable
                                  variant="outlined"
                                  :hide-spin-buttons="true"
                                  :label="pgettext('label', 'Last name')"
                                  v-model="query"
                                  v-bind="fieldProps"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <template v-if="isSearching">
                        <v-table v-if="patientsSearchResult.length > 0" hover>
                            <thead>
                            <tr>
                                <th><strong>{{ pgettext('person_name', 'Name') }}</strong></th>
                                <th><strong>{{ pgettext('label', 'Birth year') }}</strong></th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="patient in patientsSearchResult">
                                <td><strong>{{ patient.lastName }}</strong> {{ patient.firstName }}</td>
                                <td><strong>{{ patient.birthYear }}</strong></td>
                                <td>
                                    <v-btn @click="submit(patient)">
                                        <strong>{{ pgettext('action', 'Identify') }}</strong>
                                    </v-btn>
                                </td>
                            </tr>
                            </tbody>
                        </v-table>
                        <v-empty-state v-else
                                       :title="pgettext('message', 'This MCI does not contain any person with this last name.')"/>

                        <p class="mt-6 text-center">
                            <v-btn color="green" size="large" @click="submit(null)">
                                <strong>{{ pgettext('action', 'Identify a new person') }}</strong>
                            </v-btn>
                        </p>
                    </template>
                    <v-empty-state v-else :title="pgettext('message', 'Please enter the last name.')"/>
                </v-col>
            </v-row>
        </v-container>
    </main>
</template>
